import styled, { keyframes } from 'styled-components';

const moveLeftSequence = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.8) translateX(0);
  }
  20% {
    opacity: 1;
    transform: scale(1) translateX(0);
  }
  50% {
    opacity: 1;
    transform: scale(1) translateX(-80px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateX(-80px);
  }
`;

const floatMove = keyframes`
  0%, 100% {
    transform: scale(1) translateX(-80px) translateY(0);
  }
  50% {
    transform: scale(1) translateX(-80px) translateY(-5px);
  }
`;

const textSequence = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
`;

const textAppearance = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

interface SizeProps {
  size: 'small' | 'medium' | 'large';
}

const sizeMap = {
  small: {
    logo: '24px',
    fontSize: '18px',
    gap: '8px',
  },
  medium: {
    logo: '32px',
    fontSize: '24px',
    gap: '12px',
  },
  large: {
    logo: '64px',
    fontSize: '48px',
    gap: '20px',
  },
};

export const EnmonLoaderContainer = styled.div<SizeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.color.semantic.background.base};
  z-index: 10;
`;

export const LogoWrapper = styled.div<SizeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;

  svg {
    width: ${({ size }) => sizeMap[size].logo};
    height: ${({ size }) => sizeMap[size].logo};
    animation: ${moveLeftSequence} 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards, ${floatMove} 4s ease-in-out infinite 1s;
    display: block;
  }
`;

export const TextWrapper = styled.div<SizeProps>`
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translateX(calc(-50% + 40px));
  animation: ${textSequence} 0.8ms cubic-bezier(0.4, 0, 0.2, 1) both;
`;

export const EnmonText = styled.span<SizeProps>`
  display: inline-block;
  font-family: ${({ theme }) => theme.typography.fontFamily.poppins};
  font-size: ${({ size }) => sizeMap[size].fontSize};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.color.core.gray.main};
  letter-spacing: 0.5px;
  white-space: nowrap;
  line-height: 1;
  position: relative;
  animation: ${textAppearance} 0.3s cubic-bezier(0.4, 0, 0.2, 1) 1s both;
`;

export const LoadingTextWrapper = styled.div<SizeProps>`
  position: absolute;
  top: 53.5%;
  left: 48%;
  transform: translateX(-50%) translateY(60px);
  animation: ${moveLeftSequence} 0.8ms cubic-bezier(0.4, 0, 0.2, 1) both;
`;

export const LoadingText = styled.span<SizeProps>`
  display: inline-block;
  font-family: ${({ theme }) => theme.typography.fontFamily.poppins};
  font-size: ${({ theme, size }) => {
    if (size === 'large') return `${theme.typography.fontSize[4]}px`;
    if (size === 'medium') return `${theme.typography.fontSize[3]}px`;
    return `${theme.typography.fontSize[2]}px`;
  }};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  color: ${({ theme }) => theme.color.core.gray.main};
  text-align: center;
`;
